/* ==========================================================================
   NurtuBabe — Scalp Ritual landing behaviour
   · bundle selectors stay in sync (hero + offer + sticky)
   · AJAX add-to-cart → slide-out cart (falls back to normal form POST)
   · sticky add-to-cart once the buy buttons are off screen
   · gallery dots/thumbs, click-to-play videos, delivery estimate
   No dependencies. ~7 KB unminified.
   ========================================================================== */
(function () {
  'use strict';

  var R = window.sbRoutes || { cartAdd: '/cart/add.js', cartChange: '/cart/change.js', cart: '/cart', moneyFormat: '${{amount}}' };
  var HE = document.documentElement.lang === 'he';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ---------- money ---------- */
  function money(cents) {
    var fmt = R.moneyFormat || '${{amount}}';
    var n = (cents / 100);
    var withDelims = function (num, dec, t, d) {
      var parts = num.toFixed(dec).split('.');
      return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, t) + (parts[1] ? d + parts[1] : '');
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      switch (k) {
        case 'amount_no_decimals': return withDelims(n, 0, ',', '.');
        case 'amount_with_comma_separator': return withDelims(n, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelims(n, 0, '.', ',');
        default: return withDelims(n, 2, ',', '.');
      }
    });
  }

  /* ---------- product + state ---------- */
  var product = null;
  try { var pj = $('[data-sb-product]'); if (pj) product = JSON.parse(pj.textContent); } catch (e) {}
  var state = { variantId: null };

  function variantById(id) {
    if (!product) return null;
    id = Number(id);
    for (var i = 0; i < product.variants.length; i++) if (product.variants[i].id === id) return product.variants[i];
    return null;
  }

  function selectVariant(id, source) {
    state.variantId = Number(id);
    var v = variantById(id);
    $$('[data-sb-variant]').forEach(function (r) { r.checked = Number(r.value) === state.variantId; });
    if (!v) return;
    $$('[data-sb-price]').forEach(function (el) { el.textContent = money(v.price); });
    $$('[data-sb-option-label]').forEach(function (el) { el.textContent = v.title; });
    $$('[data-sb-compare]').forEach(function (el) {
      if (v.compare_at_price && v.compare_at_price > v.price) { el.textContent = money(v.compare_at_price); el.hidden = false; }
      else el.hidden = true;
    });
    $$('[data-sb-add]').forEach(function (b) {
      b.disabled = !v.available;
      var l = $('[data-sb-add-label]', b);
      if (l) { if (!l.dataset.orig) l.dataset.orig = l.textContent; l.textContent = v.available ? l.dataset.orig : (HE ? 'אזל מהמלאי' : 'Sold out'); }
    });
    var sb = $('[data-sb-sticky-add]'); if (sb) sb.disabled = !v.available;
    // show the variant's own image if it has one
    if (v.featured_media && source !== 'init') goToMedia(v.featured_media.id);
    // keep ?variant= in the URL so refresh/share keeps the choice
    if (source !== 'init' && window.history && history.replaceState) {
      var u = new URL(window.location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u.toString());
    }
  }

  /* ---------- gallery ---------- */
  var track = $('[data-sb-track]');
  function goToMedia(mediaId) {
    if (!track) return;
    var slide = $('[data-media-id="' + mediaId + '"]', track);
    if (slide) track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
  }
  if (track) {
    var dots = $$('.sb-gallery__dot'), thumbs = $$('[data-sb-thumb]'), raf;
    track.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        var i = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
        dots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); });
        thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === i); });
      });
    }, { passive: true });
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { track.scrollTo({ left: track.clientWidth * Number(t.dataset.sbThumb), behavior: 'smooth' }); });
    });
  }

  /* ---------- cart ---------- */
  var cartEl = $('[data-sb-cart]');
  var lastFocus = null;

  function fetchJSON(url, opts) {
    return fetch(url, opts).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) { var e = new Error(j.description || j.message || (HE ? 'משהו השתבש' : 'Something went wrong')); e.data = j; throw e; } return j; });
    });
  }
  function getCart() { return fetchJSON(R.cart + '.js', { headers: { Accept: 'application/json' } }); }

  function renderCart(cart) {
    $$('[data-sb-cart-count]').forEach(function (el) { el.textContent = cart.item_count; el.hidden = cart.item_count === 0; });
    if (!cartEl) return;
    var lines = $('[data-sb-cart-lines]', cartEl), empty = $('[data-sb-cart-empty]', cartEl), foot = $('[data-sb-cart-foot]', cartEl);
    lines.innerHTML = '';
    empty.hidden = cart.item_count > 0; foot.hidden = cart.item_count === 0; lines.hidden = cart.item_count === 0;
    cart.items.forEach(function (it) {
      var row = document.createElement('div');
      row.className = 'sb-cart__line';
      var img = it.image ? '<img class="sb-cart__img" src="' + it.image.replace(/(\.[a-z]+)(\?|$)/i, '$1$2') + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=160" alt="" width="72" height="72" loading="lazy">' : '<span class="sb-cart__img"></span>';
      var variant = (it.variant_title && it.variant_title !== 'Default Title') ? '<p class="sb-cart__variant">' + esc(it.variant_title) + '</p>' : '';
      var was = it.original_line_price > it.final_line_price ? '<s>' + money(it.original_line_price) + '</s>' : '';
      row.innerHTML = img +
        '<div><p class="sb-cart__name">' + esc(it.product_title) + '</p>' + variant +
        '<div class="sb-cart__qty"><button type="button" aria-label="' + (HE ? 'הפחתת כמות' : 'Decrease quantity') + '" data-q="' + (it.quantity - 1) + '">' + ICON_MINUS + '</button><span aria-live="polite">' + it.quantity + '</span><button type="button" aria-label="' + (HE ? 'הגדלת כמות' : 'Increase quantity') + '" data-q="' + (it.quantity + 1) + '">' + ICON_PLUS + '</button></div></div>' +
        '<div><p class="sb-cart__price">' + was + money(it.final_line_price) + '</p><button type="button" class="sb-cart__remove" data-q="0">' + (HE ? 'הסרה' : 'Remove') + '</button></div>';
      $$('[data-q]', row).forEach(function (b) { b.addEventListener('click', function () { changeLine(it.key, Number(b.dataset.q)); }); });
      lines.appendChild(row);
    });
    var sub = $('[data-sb-cart-subtotal]', cartEl); if (sub) sub.textContent = money(cart.total_price);
    var ship = $('[data-sb-cart-ship]', cartEl), th = Number(cartEl.dataset.freeThreshold || 0);
    if (ship && th > 0) {
      if (cart.total_price >= th) { ship.innerHTML = esc(cartEl.dataset.freeLabel); }
      else {
        var pct = Math.min(100, Math.round(cart.total_price / th * 100));
        ship.innerHTML = esc(cartEl.dataset.freeProgress).replace('[amount]', '<b>' + money(th - cart.total_price) + '</b>') + '<span class="sb-cart__bar"><i style="width:' + pct + '%"></i></span>';
      }
      ship.hidden = cart.item_count === 0;
    }
  }
  var ICON_MINUS = '<svg class="sb-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="M6 12h12"/></svg>';
  var ICON_PLUS = '<svg class="sb-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="M12 6v12M6 12h12"/></svg>';
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }

  function changeLine(key, qty) {
    var err = cartEl && $('[data-sb-cart-error]', cartEl);
    if (err) err.hidden = true;
    fetchJSON(R.cartChange, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: Math.max(0, qty) }) })
      .then(renderCart)
      .catch(function (e) { if (err) { err.textContent = e.message; err.hidden = false; } });
  }

  function openCart() {
    if (!cartEl) { window.location.href = R.cart; return; }
    lastFocus = document.activeElement;
    cartEl.hidden = false;
    requestAnimationFrame(function () { cartEl.classList.add('is-open'); });
    document.body.classList.add('sb-cart-open');
    var panel = $('.sb-cart__panel', cartEl); if (panel) panel.focus();
  }
  function closeCart() {
    if (!cartEl) return;
    cartEl.classList.remove('is-open');
    document.body.classList.remove('sb-cart-open');
    setTimeout(function () { cartEl.hidden = true; }, 300);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  $$('[data-sb-cart-open]').forEach(function (a) {
    a.addEventListener('click', function (e) { if (!cartEl) return; e.preventDefault(); getCart().then(renderCart).then(openCart).catch(function () { window.location.href = R.cart; }); });
  });
  $$('[data-sb-cart-close]').forEach(function (b) { b.addEventListener('click', closeCart); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && cartEl && !cartEl.hidden) closeCart(); });

  function addToCart(btn, errEl) {
    var id = state.variantId;
    if (!id) return;
    if (btn) { btn.classList.add('is-loading'); btn.setAttribute('aria-busy', 'true'); }
    if (errEl) errEl.hidden = true;
    return fetchJSON(R.cartAdd, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: id, quantity: 1 }] }) })
      .then(getCart)
      .then(function (cart) { renderCart(cart); openCart(); })
      .catch(function (e) { if (errEl) { errEl.textContent = e.message; errEl.hidden = false; } else alert(e.message); })
      .then(function () { if (btn) { btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy'); } });
  }

  /* ---------- forms ---------- */
  var forms = $$('[data-sb-form]');
  forms.forEach(function (f) {
    f.addEventListener('change', function (e) { if (e.target.matches('[data-sb-variant]')) selectVariant(e.target.value, 'user'); });
    f.addEventListener('submit', function (e) {
      if (!window.fetch) return; // no-JS / old browser: normal POST to /cart/add
      e.preventDefault();
      var checked = $('[data-sb-variant]:checked', f); if (checked) state.variantId = Number(checked.value);
      addToCart($('[data-sb-add]', f), $('[data-sb-form-error]', f));
    });
  });
  var firstChecked = $('[data-sb-variant]:checked');
  if (firstChecked) selectVariant(firstChecked.value, 'init');

  /* ---------- sticky bar ---------- */
  var sticky = $('[data-sb-sticky]');
  if (sticky && forms.length && 'IntersectionObserver' in window) {
    var heroForm = forms[0], visibleForms = new Set(), pastHero = false;
    var update = function () {
      var show = pastHero && visibleForms.size === 0 && !(cartEl && !cartEl.hidden);
      sticky.classList.toggle('is-visible', show);
      sticky.setAttribute('aria-hidden', String(!show));
      $$('button', sticky).forEach(function (b) { b.tabIndex = show ? 0 : -1; });
    };
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) visibleForms.add(en.target); else visibleForms.delete(en.target);
        if (en.target === heroForm) pastHero = !en.isIntersecting && en.boundingClientRect.top < 0;
      });
      update();
    }, { threshold: 0 });
    forms.forEach(function (f) { io.observe(f); });
    var sa = $('[data-sb-sticky-add]', sticky);
    if (sa) sa.addEventListener('click', function () { addToCart(sa, null); });
  }

  /* ---------- smooth-scroll buttons ---------- */
  $$('[data-sb-scroll]').forEach(function (el) {
    el.addEventListener('click', function (e) {
      var t = $(el.dataset.sbScroll); if (!t) return;
      e.preventDefault(); t.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  /* ---------- videos: tap to play, one at a time ---------- */
  $$('[data-sb-video]').forEach(function (frame) {
    var v = $('video', frame), b = $('.sb-reel__play', frame);
    if (!v || !b) return;
    v.removeAttribute('controls');
    b.addEventListener('click', function () {
      $$('[data-sb-video] video').forEach(function (o) { if (o !== v) o.pause(); });
      v.setAttribute('controls', ''); v.play();
    });
    v.addEventListener('play', function () { frame.classList.add('is-playing'); });
    v.addEventListener('pause', function () { frame.classList.remove('is-playing'); });
    v.addEventListener('ended', function () { frame.classList.remove('is-playing'); });
  });

  /* ---------- delivery estimate (business days, from policy numbers) ---------- */
  function addBusinessDays(d, n) { var c = 0; while (c < n) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) c++; } return d; }
  $$('[data-sb-eta]').forEach(function (el) {
    var min = Number(el.dataset.min), max = Number(el.dataset.max);
    if (!min || !max) return;
    var f = function (d) { return d.toLocaleDateString(HE ? 'he-IL' : 'en-US', { month: 'short', day: 'numeric' }); };
    el.innerHTML = (HE ? 'מועד הגעה משוער בארה״ב: ' : 'Estimated U.S. delivery: ') + '<b>' + f(addBusinessDays(new Date(), min)) + ' – ' + f(addBusinessDays(new Date(), max)) + '</b>';
  });

  /* ---------- keep header count right after bfcache restore ---------- */
  window.addEventListener('pageshow', function (e) { if (e.persisted) getCart().then(renderCart).catch(function () {}); });
})();
